import React, { PureComponent } from "react";
import { Img } from "arv-reactcomponents";

import Anchor from "../../../Anchor";
import { GETAPP, Endpoints } from "npmlinks-constants";

import Analytics from "../../../../analytics";
import Event from "../../../../analytics/eventFactory";

class GetApp extends PureComponent {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    Analytics.trackEvent({
      action: Event.action.GET_APP,
      category: Event.category.TOP_ABOVE_MENU_CTR,
      interaction: true,
    });
  }

  render() {
    const alt = "NNNOW image";
    const { LABEL, logoClass, className } = this.props;
    return (
      <div className="nw-getapp-container">
        <Anchor.component
          className="nw-getapp-anchor nw-desktop-only"
          to={GETAPP.PATH}
          href={GETAPP.PATH}
          target="_self"
          onClick={this.handleClick}
        >
          <Img className={logoClass} src={Endpoints.GETAPP} alt={alt} />
          <span className={`nw-actionbuttons-text ${className}`}>
            {" "}
            {LABEL}{" "}
          </span>
        </Anchor.component>
      </div>
    );
  }
}

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: GetApp,
  component: GetApp,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Header/ActionButtons/GetApp/index.js